import React, { useState } from 'react';
import api from '../services/api';

const ACTOR_TYPES = [
  { value: 'threat_actor', label: 'Threat actor' },
  { value: 'intrusion_set', label: 'Intrusion set' },
  { value: 'campaign', label: 'Campaign' },
  { value: 'malware_author', label: 'Malware author' },
  { value: 'unknown', label: 'Unknown' },
];

const RISK_LEVELS = ['low', 'medium', 'high', 'critical'];

function AddActorForm({ caseId, onCreated, disabled = false }) {
  const [form, setForm] = useState({
    display_name: '',
    actor_type: 'threat_actor',
    risk_level: 'medium',
    summary: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    if (disabled || !form.display_name.trim()) return;
    setSaving(true);
    setError('');
    try {
      const payload = {
        display_name: form.display_name.trim(),
        actor_type: form.actor_type,
        risk_level: form.risk_level,
        summary: form.summary.trim() || undefined,
      };
      if (caseId) payload.case_id = caseId;
      const res = await api.post('/hdp/actors', payload);
      setForm({ display_name: '', actor_type: 'threat_actor', risk_level: 'medium', summary: '' });
      onCreated?.(res.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to add actor');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="entity-inline-form" onSubmit={submit} style={{ marginBottom: 'var(--spacing-lg)' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'flex-end' }}>
        <div style={{ flex: '1 1 180px' }}>
          <label className="form-label">Display name</label>
          <input
            className="form-input"
            value={form.display_name}
            onChange={(e) => setForm((prev) => ({ ...prev, display_name: e.target.value }))}
            placeholder="Actor / campaign name"
            required
            disabled={disabled || saving}
          />
        </div>
        <div style={{ flex: '0 1 150px' }}>
          <label className="form-label">Type</label>
          <select
            className="form-input"
            value={form.actor_type}
            onChange={(e) => setForm((prev) => ({ ...prev, actor_type: e.target.value }))}
            disabled={disabled || saving}
          >
            {ACTOR_TYPES.map((type) => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </select>
        </div>
        <div style={{ flex: '0 1 120px' }}>
          <label className="form-label">Risk</label>
          <select
            className="form-input"
            value={form.risk_level}
            onChange={(e) => setForm((prev) => ({ ...prev, risk_level: e.target.value }))}
            disabled={disabled || saving}
          >
            {RISK_LEVELS.map((level) => (
              <option key={level} value={level}>{level}</option>
            ))}
          </select>
        </div>
        <div style={{ flex: '1 1 160px' }}>
          <label className="form-label">Summary</label>
          <input
            className="form-input"
            value={form.summary}
            onChange={(e) => setForm((prev) => ({ ...prev, summary: e.target.value }))}
            placeholder="Optional"
            disabled={disabled || saving}
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={disabled || saving}>
          {saving ? 'Adding...' : 'Add actor'}
        </button>
      </div>
      {error && <p style={{ color: 'var(--danger, #f66)', marginTop: '8px' }}>{error}</p>}
    </form>
  );
}

export default AddActorForm;
